import { useState, useEffect, useContext, useMemo, useRef } from "react";
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { Divider, message, Popover } from 'antd';
import { IMAGE_TYPE, RESOURCE_TYPE, CLOTH_COLOR_TYPE } from '@utils/CONST'
import { workflowOfSendTask, doHDPreview } from '@utils/workflowOfBuildTaskV2';
import DownloadBtn from '../../DownloadBtn'
import { workflowOfLoadTaskInfo, workflowOfReGenerate } from '@utils/workflowOfBuildTaskV2';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '@utils/AppContext';
import API from '@api/api'
import { MoreOutlined } from '@ant-design/icons';

const PicModalFooter = (props) => {
    const { item, currentViewIsHD, setCurrentViewIsHD } = props
    const { setGlobalTaskReadFlag } = useContext(AppContext)
    const navigate = useNavigate()
    const [imageUrl, setImageUrl] = useState()
    useEffect(() => {
        const fetchImageUrl = async () => {
            try {
                let res = await API.commonDownload({ taskId: item.taskId });
                if (res?.code != 0) throw new Error(res?.message);
                const image = res.data;
                setImageUrl(image)
            } catch (error) {
                console.error('Failed to fetch image:', error);
            }
        }
        if (item) {
            fetchImageUrl();
        }
    }, [item])

    const handleClick = async (jumpTotype, targetType = "inputImage") => {
        let noWaterRes = await API.commonDownload({ taskId: item?.taskId })
        if (noWaterRes?.code != 0) throw new Error(noWaterRes?.message)
        const image = noWaterRes.data
        const res = await workflowOfSendTask(jumpTotype, image, targetType)
        if (!res) return
        const { pathname, options } = res
        navigate(pathname, options)
    }

    const HDClick = () => {
        if (currentViewIsHD) {
            setCurrentViewIsHD(false)
        } else {
            if (item?.results?.[0]?.hdImage) {
                setCurrentViewIsHD(true)
            } else {
                doHDPreview(item.taskId, item.imageType, () => {
                    props.fetchProjectDetail()
                })
            }
        }
    }

    const rebuildClick = async (commidityOldDataRebuild) => {
        const succeededItem = item
        if (succeededItem) {
            try {
                const res = await workflowOfLoadTaskInfo(succeededItem.imageType, succeededItem.taskId, commidityOldDataRebuild)
                if (!res) return
                const { pathname, options } = res
                navigate(pathname, options)
            } catch (err) {
                message.warning(err.message)
            }
        } else {
            message.warning('请先等待生成成功后再重新编辑')
        }
    }

    const createAgain = async () => {
        const succeededItem = item
        if (succeededItem) {
            try {
                const taskID = succeededItem.taskId
                const res = await workflowOfReGenerate(succeededItem.imageType, taskID)
                if (!res) return
                const { disabled, pathname, options } = res
                if (disabled) {
                    message.warning("版本更新，请重新编辑后再重新生成")
                    navigate(pathname, options)
                } else {
                    message.success('生成中，请稍后！')
                    setGlobalTaskReadFlag(prev => !prev)
                    props.fetchProjectDetail()
                }
            } catch (err) {
                message.warning(err.message)
            }
        } else {
            message.warning('请先等待生成成功后再重新生成')
        }
    }

    const extractionClick = () => {
        window.open(imageUrl ? `/home/image_extraction?url=${encodeURIComponent(imageUrl)}` : `/home/image_extraction`, '_blank')
    }

    const resizeClick = () => {
        window.open(imageUrl ? `/home/imageResize?url=${encodeURIComponent(imageUrl)}` : `/home/imageResize`, '_blank')
    }

    const IsEiEdit = useMemo(() => {
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX
    }, [item])

    const popoverContent = () => (
        <div className={styles.popover_content}>
            {
                (item.imageType != IMAGE_TYPE.COMMODITY && item.imageType != IMAGE_TYPE.COMMODITYRECOLOR && item.imageType != IMAGE_TYPE.CLOTH_RECOLOR) &&
                <span
                    className={styles.footer_text}
                    onClick={() => navigate("/home/aiEdit", { state: { menuKey: 'handRepair', picUrl: imageUrl } })}>
                    <Iconfont type="icon-handRepairOutlined" className={styles.Icon} />手部修复</span>
            }
            <span
                className={styles.footer_text}
                onClick={() => navigate("/home/aiEdit", { state: { menuKey: 'magicErase', picUrl: imageUrl } })}>
                <Iconfont type="icon-magicRemoveOutlined" className={styles.Icon} />魔法擦除</span>
            <span className={styles.footer_text} onClick={extractionClick}><Iconfont type="icon-mattingOutlined" className={styles.Icon} />智能抠图</span>
            <span className={styles.footer_text} onClick={resizeClick}><Iconfont type="icon-picResizeOutlined" className={styles.Icon} />高清改尺寸</span>
            <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.CLOTH_RECOLOR)} ><Iconfont type="icon-recolorOutlined" className={styles.Icon} />服饰换色</span>
            {(item.imageType === IMAGE_TYPE.FUSION_WEAR || item.imageType === IMAGE_TYPE.GRASS_PLANT) &&
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL)}><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />换模特/背景</span>}
            {
                (item.imageType != IMAGE_TYPE.COMMODITY &&
                    item.imageType != IMAGE_TYPE.FUSION_WEAR &&
                    item.imageType != IMAGE_TYPE.COMMODITYRECOLOR
                    && (item.imageType != IMAGE_TYPE.CLOTH_RECOLOR || item?.clothReColorIsPerson)) &&
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.FUSION_WEAR, RESOURCE_TYPE.FUSIONWEAR_MODEL)} ><Iconfont type="icon-outfitSmallOutlined" className={styles.Icon} />搭配上身</span>
            }
            {
                (item.imageType != IMAGE_TYPE.COMMODITY &&
                    item.imageType != IMAGE_TYPE.GRASS_PLANT &&
                    item.imageType != IMAGE_TYPE.COMMODITYRECOLOR &&
                    (item.imageType != IMAGE_TYPE.CLOTH_RECOLOR || item?.clothReColorIsPerson)) &&
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.GRASS_PLANT)} ><Iconfont type="icon-sProductshowcaseOutlined" className={styles.Icon} />种草图</span>
            }
            <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.IMAGE_TO_VIDEO)} ><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />图生视频</span>
        </div>
    )

    const showBtnList = (
        item.imageType === IMAGE_TYPE.CLOTHES ?
            <>
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL)}><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />换模特/背景</span>
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.POSE_TRYON)}><Iconfont type="icon-poseFantasyOutlined" className={styles.Icon} />姿势裂变</span>
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON)}><Iconfont type="icon-glassesOutlined" className={styles.Icon} />眼镜试戴</span>
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON)}><Iconfont type="icon-sametryOutlined" className={styles.Icon} />同版型试衣</span>
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES)}><Iconfont type="icon-shoesOutlined" className={styles.Icon} />鞋子上脚</span>
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL_VIDEO)}><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />动作模仿</span>
                <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.COMMODITYRECOLOR)} ><Iconfont type="icon-recolorOutlined" className={styles.Icon} />商品换色</span>

            </> : (item.imageType === IMAGE_TYPE.MODEL ||
                item.imageType === IMAGE_TYPE.FUSION_WEAR ||
                item.imageType === IMAGE_TYPE.GRASS_PLANT ||
                (item.imageType === IMAGE_TYPE.CLOTH_RECOLOR && item.mode === CLOTH_COLOR_TYPE.SIM_RECOLOR) ||
                (item.imageType === IMAGE_TYPE.CLOTH_RECOLOR && item.mode === CLOTH_COLOR_TYPE.CLOTH_RECOLOR && item.clothReColorIsPerson)) ?
                <>
                    <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL)} ><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />AI试衣</span>
                    <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.POSE_TRYON)}><Iconfont type="icon-poseFantasyOutlined" className={styles.Icon} />姿势裂变</span>
                    <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON)}><Iconfont type="icon-glassesOutlined" className={styles.Icon} />眼镜试戴</span>
                    <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON)}><Iconfont type="icon-sametryOutlined" className={styles.Icon} />同版型试衣</span>
                    <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES)}><Iconfont type="icon-shoesOutlined" className={styles.Icon} />鞋子上脚</span>
                    <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL_VIDEO)}><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />动作模仿</span>
                    <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.COMMODITYRECOLOR)} ><Iconfont type="icon-recolorOutlined" className={styles.Icon} />商品换色</span>
                </> : item.imageType === IMAGE_TYPE.MODEL_VIDEO ? null : item.imageType === IMAGE_TYPE.SHOES ?
                    <>
                        <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL)} ><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />AI试衣</span>
                        <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.POSE_TRYON)}><Iconfont type="icon-poseFantasyOutlined" className={styles.Icon} />姿势裂变</span>
                        <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON)}><Iconfont type="icon-glassesOutlined" className={styles.Icon} />眼镜试戴</span>
                        <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON)}><Iconfont type="icon-sametryOutlined" className={styles.Icon} />同版型试衣</span>
                        <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL)} ><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />换模特/背景</span>
                        <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL_VIDEO)}><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />动作模仿</span>
                        <Divider type="vertical" />
                        <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.COMMODITYRECOLOR)} ><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />商品换色</span>
                    </> : (item.imageType === IMAGE_TYPE.COMMODITYRECOLOR || (item.imageType === IMAGE_TYPE.CLOTH_RECOLOR && item.mode === CLOTH_COLOR_TYPE.CLOTH_RECOLOR && !item.clothReColorIsPerson)) ?
                        <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.COMMODITY)} ><Iconfont type="icon-commidityOutlined" className={styles.Icon} />AI商品</span> :
                        item.imageType === IMAGE_TYPE.COMMODITY ?
                            <span className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.COMMODITYRECOLOR)} ><Iconfont type="icon-recolorOutlined" className={styles.Icon} />商品换色</span> :
                            item.imageType === IMAGE_TYPE.POSE_TRYON ?
                                <>
                                    <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL)}><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />换模特/背景</p>
                                    <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL)} ><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />AI试衣</p>
                                    <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES)}><Iconfont type="icon-shoesOutlined" className={styles.Icon} />鞋子上脚</p>
                                    <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON)}><Iconfont type="icon-glassesOutlined" className={styles.Icon} />眼镜试戴</p>
                                    <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON)}><Iconfont type="icon-sametryOutlined" className={styles.Icon} />同版型试衣</p>
                                    <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL_VIDEO)}><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />动作模仿</p>
                                    <Divider type="vertical" />
                                    <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.COMMODITYRECOLOR)} ><Iconfont type="icon-recolorOutlined" className={styles.Icon} />商品换色</p>
                                </> :
                                item.imageType === IMAGE_TYPE.GLASSES_TRYON ?
                                    <>
                                        <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL)}><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />换模特/背景</p>
                                        <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL)} ><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />AI试衣</p>
                                        <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES)}><Iconfont type="icon-shoesOutlined" className={styles.Icon} />鞋子上脚</p>
                                        <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON)}><Iconfont type="icon-sametryOutlined" className={styles.Icon} />同版型试衣</p>
                                        <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.POSE_TRYON)}><Iconfont type="icon-poseFantasyOutlined" className={styles.Icon} />姿势裂变</p>
                                        <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL_VIDEO)}><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />动作模仿</p>
                                        <Divider type="vertical" />
                                        <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.COMMODITYRECOLOR)} ><Iconfont type="icon-recolorOutlined" className={styles.Icon} />商品换色</p>
                                    </> :
                                    item.imageType === IMAGE_TYPE.SIM_TRYON ?
                                        <>
                                            <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL)}><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />换模特/背景</p>
                                            <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL)} ><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />AI试衣</p>
                                            <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES)}><Iconfont type="icon-shoesOutlined" className={styles.Icon} />鞋子上脚</p>
                                            <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON)}><Iconfont type="icon-glassesOutlined" className={styles.Icon} />眼镜试戴</p>
                                            <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.POSE_TRYON)}><Iconfont type="icon-poseFantasyOutlined" className={styles.Icon} />姿势裂变</p>
                                            <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.MODEL_VIDEO)}><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />动作模仿</p>
                                            <Divider type="vertical" />
                                            <p className={styles.footer_text} onClick={() => handleClick(IMAGE_TYPE.COMMODITYRECOLOR)} ><Iconfont type="icon-recolorOutlined" className={styles.Icon} />商品换色</p>
                                        </> :
                                        null
    )

    return (
        <div className={styles.PicModalFooter}>
            {
                (IsEiEdit || item?.orgData) ? <span></span> : <div className={styles.footer}>
                    {
                        (item.imageType != IMAGE_TYPE.MODEL_VIDEO && item.imageType != IMAGE_TYPE.IMAGE_TO_VIDEO) && <>
                            {showBtnList}
                            <Popover placement="bottom" content={popoverContent}>
                                <span className={styles.footer_text}><MoreOutlined /> 更多功能</span>
                            </Popover>
                            <Divider type="vertical" />
                        </>
                    }
                    {
                        <>
                            <span className={styles.footer_text} onClick={() => rebuildClick()}><Iconfont type="icon-rebuildOutlined" className={styles.Icon} />重新编辑</span>
                            <span className={styles.footer_text} onClick={() => {
                                // 商品旧数据直接跳到重新编辑
                                if (item.imageType === IMAGE_TYPE.COMMODITY && item.version !== 'V3.8.20251127') {
                                    rebuildClick(true)
                                } else createAgain()
                            }}><Iconfont type="icon-generateOutlined" className={styles.Icon} />再次生成</span>
                            {
                                (item?.imageType != IMAGE_TYPE.IMAGE_TO_VIDEO &&
                                    item?.imageType != IMAGE_TYPE.MODEL_VIDEO &&
                                    item?.imageType != IMAGE_TYPE.GRASS_PLANT) &&
                                <>
                                    <Divider type="vertical" />
                                    <span className={styles.footer_text} onClick={HDClick}>
                                        <Iconfont type={currentViewIsHD ? 'icon-closeHDOutlined' : 'icon-HDOutlined'} className={styles.Icon} />
                                        {currentViewIsHD ? '关闭高清' : '高清预览'}
                                    </span>
                                </>
                            }
                        </>
                    }
                </div>
            }
            <DownloadBtn
                item={item}
                IsEiEdit={IsEiEdit}
                fetchProjectDetail={props.fetchProjectDetail} />
        </div>
    )
}

export default PicModalFooter